import React from "react";
// Default theme
import "@splidejs/react-splide/css";

// or other themes
import "@splidejs/react-splide/css/skyblue";
import "@splidejs/react-splide/css/sea-green";

// or only core styles
import "@splidejs/react-splide/css/core";
import PartnersSlider from "./PartnersLogo";
function Partners() {
  return (
    <div>
      <section class="bg-white ">
        <div class="py-8  lg:py-16 mx-auto max-w-screen-xl px-4">
          <h2 class="mb-8 lg:mb-16 text-3xl font-extrabold tracking-tight leading-tight text-center text-blue-400">
            Partner Company's
          </h2>
          <PartnersSlider />
        </div>
      </section>
    </div>
  );
}

export default Partners;
